<template>
  <div class="dashboard-container">
    <side-bar />
    <div class="main-content">
      <h2>AI Agent Statistics</h2>
      <hr class="h2"/>
      <div class="container">
        <component src="https://c2hbe361.caspio.com/dp/76bfd0009e1d23c506874ee69f06/emb" :is="'script'"></component>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
  name: 'BotStatistics',
  components: {
    SideBar
  }
}
</script>